// extracted by mini-css-extract-plugin
export var dividerLine = "_ao-3";
export var itemImage = "_ao-9";
export var lightDivider = "_ao-4";
export var modalContent = "_ao-5";
export var modalContentCompact = "_ao-6";
export var productCard = "_ao-a";
export var productImage = "_ao-b";
export var productImageCompact = "_ao-7";
export var productImagePlaceholder = "_ao-c";
export var productImagePlaceholderCompact = "_ao-8";
export var progressBarBackground = "_ao-1";
export var progressBarContainer = "_ao-0";
export var progressBarFill = "_ao-2";